import React, { FC } from 'react';

import cn from 'classnames';

import { TrashBinIcon, LaunchLinkIcon } from 'src/atoms';

import styles from 'src/components/workspaces-components/styles.module.scss';

import { ColumnAlignOptions, TableHeaderColumns } from 'src/interfaces';
import truncate from 'lodash/truncate';

import { ACCESS_COL_IDS, TRUNCATE_NAME_WIDTH } from './constants';
import { CheckboxIconChecked } from 'src/atoms/CustomizedCheckbox/adds/CheckboxIcons';
import { WORKSPACE_ACTIONS } from 'src/constants/workspacesConstants';
import { ACCESS_MODE, TAccessItem } from 'src/interfaces/workspacesReduxShapes';

type ActionsBlockProps = {
  userName: string;
  userEmail: string;
  userId: string;
  onActionClick: (action: WORKSPACE_ACTIONS, userName?: string, userEmail?: string, userId?: string) => void;
};

export const ACCESS_TABLE_HEADINGS_LIST: TableHeaderColumns = [
  {
    label: 'User Name',
    id: ACCESS_COL_IDS.NAME,
    isSortable: false,
    isOpen: false,
    width: 30,
    sortOptions: null,
    align: ColumnAlignOptions.LEFT
  },
  {
    label: 'Email',
    id: ACCESS_COL_IDS.EMAIL,
    width: 30,
    isSortable: false,
    isOpen: false,
    sortOptions: null,
    align: ColumnAlignOptions.CENTER
  },
  {
    label: 'Can Edit',
    id: ACCESS_COL_IDS.EDIT,
    width: 10,
    isSortable: false,
    isOpen: false,
    sortOptions: null,
    align: ColumnAlignOptions.CENTER
  },
  {
    label: 'Can View',
    id: ACCESS_COL_IDS.VIEW,
    width: 10,
    isSortable: false,
    isOpen: false,
    sortOptions: null,
    align: ColumnAlignOptions.CENTER
  },
  {
    label: 'Actions',
    id: ACCESS_COL_IDS.ACTIONS,
    width: 15,
    isSortable: false,
    isOpen: false,
    sortOptions: null,
    align: ColumnAlignOptions.CENTER
  }
];

export const renderTableContent = (
  colId: ACCESS_COL_IDS,
  row: TAccessItem,
  onActionClick: (action: WORKSPACE_ACTIONS, userName: string, userEmail: string) => void
): JSX.Element => {
  switch (colId) {
    case ACCESS_COL_IDS.NAME: {
      const name = truncate(row?.username, { length: TRUNCATE_NAME_WIDTH }).trim();

      return <span className={cn(styles.tableText, styles.tableName)}>{name}</span>;
    }

    case ACCESS_COL_IDS.EMAIL: {
      const name = truncate(row?.email, { length: TRUNCATE_NAME_WIDTH }).trim();

      return <span className={cn(styles.tableText, styles.tableName)}>{name}</span>;
    }

    case ACCESS_COL_IDS.EDIT: {
      const isEdit =
        row?.access_mode === ACCESS_MODE.EDITOR ? <CheckboxIconChecked checkedBoxClass={styles.tableMarkIcon} /> : '';

      return <span className={styles.tableAccessText}>{isEdit}</span>;
    }

    case ACCESS_COL_IDS.VIEW: {
      const isView =
        row?.access_mode === ACCESS_MODE.VIEWER ? <CheckboxIconChecked checkedBoxClass={styles.tableMarkIcon} /> : '';

      return <span className={styles.tableAccessText}>{isView}</span>;
    }

    case ACCESS_COL_IDS.ACTIONS:
      return (
        <ActionsBlock userName={row.username} userEmail={row.email} userId={row.id} onActionClick={onActionClick} />
      );

    default:
      return <></>;
  }
};

const ActionsBlock: FC<ActionsBlockProps> = ({ onActionClick, userName, userEmail, userId }) => {
  return (
    <div className={styles.actions}>
      <button
        className={styles.actionBtn}
        type="button"
        onClick={() => onActionClick(WORKSPACE_ACTIONS.EDIT_ACCESS, userName, userEmail, userId)}
      >
        <LaunchLinkIcon />
        <span className={styles.actionPopover}>Edit access rights</span>
      </button>

      <button
        className={cn(styles.actionBtn)}
        type="button"
        onClick={() => onActionClick(WORKSPACE_ACTIONS.DELETE, userName, userEmail, userId)}
      >
        <TrashBinIcon />
        <span className={styles.actionPopover}>Delete user</span>
      </button>
    </div>
  );
};
